import { Sparkles, AlertTriangle, Info } from "lucide-react";

export const HowItWorks = ({ onOpenHelp, showRobloxWarning }) => {
  return (
    <div className="rounded-2xl border border-zinc-800/80 bg-[#101116] p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-zinc-100 font-semibold">
          <Sparkles className="w-4 h-4 text-rose-400" />
          <span>How it works</span>
        </div>
        <button
          data-testid="more-help-btn"
          onClick={onOpenHelp}
          className="text-[11px] font-medium text-zinc-300 hover:text-white bg-zinc-800/70 hover:bg-zinc-700/80 border border-zinc-700/60 rounded-full px-3 py-1.5 transition"
        >
          More Help?
        </button>
      </div>
      <div className="space-y-3 text-[13px] text-zinc-400 leading-relaxed">
        <p>
          Each color is a <span className="text-zinc-200 font-medium">height layer</span> covering a min-max range. Layers higher in the list cover layers below them where ranges overlap.
        </p>
        <p>
          <span className="text-zinc-200 font-medium">Manual Paint</span> fills each layer&apos;s band with a solid color and unlocks brush, gradient-brush, and fill tools.
        </p>
        <p>
          <span className="text-zinc-200 font-medium">Elevation</span> assigns materials by height and can blend between layer centers for soft transitions.
        </p>
        <p>
          <span className="text-zinc-200 font-medium">Material Mix</span> combines two or more materials in one layer using adjustable patterns.
        </p>
        <p>
          <span className="text-zinc-200 font-medium">Steep Slopes</span> is recommended last. It applies one material at or above a cliff angle, or at or below it for flatter terrain, while optionally protecting one or more existing materials from changes.
        </p>
        <p>
          Drag the grip on any layer row to reorder. Scroll on a canvas to zoom.
        </p>
        <div
          data-testid="how-it-works-remove-defaults-tip"
          className="mt-3 flex gap-2 rounded-lg border border-rose-500/20 bg-rose-500/5 p-3 text-[12px] text-zinc-300 leading-relaxed"
        >
          <Info className="w-4 h-4 flex-shrink-0 mt-0.5 text-rose-400" />
          <div>
            <span className="font-semibold text-rose-300">Tip:</span> The default
            Roblox palette includes man-made materials like <em>WoodPlanks</em>,{" "}
            <em>Brick</em>, <em>Asphalt</em>, <em>Concrete</em>,{" "}
            <em>Pavement</em> and <em>Cobblestone</em> that look unrealistic on
            natural terrain. Consider deleting the layers you won&apos;t use — keep
            them only if you specifically want that look.
          </div>
        </div>
        {showRobloxWarning && (
          <div
            data-testid="how-it-works-roblox-warning"
            className="mt-3 flex gap-2 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 text-[12px] text-amber-200 leading-relaxed"
          >
            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-400" />
            <div>
              <span className="font-semibold text-amber-300">Warning:</span> Avoid using the Roblox Terrain <em>Water</em> material directly on generated heightmaps for Roblox; its procedural surface deformation can introduce unintended height variations and uneven terrain surfaces.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
